import {cleanTitle, defaultImageName} from '../../../smartpak/misc.js';
import $ from 'jquery';
import ko from 'knockout';
import recentlyViewedProducts from '../../../smartpak/recentlyviewedproducts';

let ids;

// eslint-disable-next-line no-empty-function
function error() {}

const prodId = smartPak.pageData.productId,
    maxProductCount = 3,
    recentlyViewed = {
        _recentlyViewedProducts: recentlyViewedProducts,
        _recentlyViewedProductClassIds: function () {
            ids = ids ? ids : recentlyViewed._recentlyViewedProducts.getRecentlyViewedProductClassIds();
            return ids;
        },
        _isProductClass: function (url) {
            return url && /p(s|t)\/(.+)(\d+)/gi.test(url);
        },
        _idsTodisplay: function () {
            var isProdCount = this._isProductClass(location.href);

            if (isProdCount) {
                return $.isArray(recentlyViewed._recentlyViewedProductClassIds())
                    ? ids.slice(0, maxProductCount).join('!')
                    : '';
            }
            return $.isArray(recentlyViewed._recentlyViewedProductClassIds()) ? ids.join('!') : '';
        },
        _hasRecentlyViewedProducts: function () {
            return $.isArray(recentlyViewed._recentlyViewedProductClassIds()) && ids.length > 0;
        },
        _containsOneSameProductClassId: function () {
            return (
                recentlyViewed._hasRecentlyViewedProducts() &&
                recentlyViewed._recentlyViewedProductClassIds().length === 1 &&
                recentlyViewed._recentlyViewedProductClassIds()[0] === prodId
            );
        },
        _hide: function () {
            $('#recentlyViewedCon').hide();
            $('.dashedRight').toggleClass('dashedRight');
        },
        _show: function (dataItems) {
            var $list = $('#recentViewList'),
                recentProd;

            if ($list.length) {
                if (this._isProductClass(location.href)) {
                    recentProd = ko.dataFor(document.getElementById('productClassCon'));

                    recentProd.updateRecentlyViewedProducts(dataItems);
                } else {
                    ko.applyBindings(
                        {
                            products: dataItems
                        },
                        $list.get(0)
                    );
                }
            }
        },
        _formatData: function (data) {
            var dataItems = $.map(data, function (item) {
                return $.extend(item, {
                    Title: cleanTitle(item.Title),
                    thumbnail: defaultImageName(item, item.ImagePath) + '?width=120',
                    medium: defaultImageName(item, item.ImagePath) + '?width=300',
                    Url: item.Url,
                    Id: item.Id
                });
            });

            return dataItems;
        },
        _display: function (data) {
            var formattedDataItems = recentlyViewed._formatData(data);

            recentlyViewed._show(formattedDataItems);
        },
        _processRecentlyViewedProducts: function (data) {
            if (data && data.length) {
                recentlyViewed._display(data);
            }
        },
        _getProductClassData: function (delimitedIDs, success, error) {
            var DELIMITER = '!';

            return smartPak.api.product.getProductClassDTOList(delimitedIDs.split(DELIMITER)).done(success).fail(error);
        },
        init: function (productId) {
            if (!recentlyViewed._hasRecentlyViewedProducts() || recentlyViewed._containsOneSameProductClassId()) {
                recentlyViewed._hide();
            } else if ($.isArray(ids)) {
                this._getProductClassData(recentlyViewed._idsTodisplay())
                    .done(recentlyViewed._processRecentlyViewedProducts.bind(this))
                    .fail(error);
            }

            recentlyViewed._recentlyViewedProducts.updateRecentlyViewedProductClasses(productId || prodId);
            recentlyViewed._recentlyViewedProducts.loadBvReviewStars('.productReviewStars');
        }
    };

export default recentlyViewed;
